import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Email i pavlefshëm'),
  password: z.string().min(8, 'Fjalëkalimi duhet të ketë të paktën 8 karaktere'),
});

export const refreshTokenSchema = z.object({
  refreshToken: z.string().min(1, 'Refresh token është i detyrueshëm'),
});

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, 'Fjalëkalimi aktual është i detyrueshëm'),
  newPassword: z
    .string()
    .min(8, 'Fjalëkalimi duhet të ketë të paktën 8 karaktere'),
});

export const setInitialPasswordSchema = z.object({
  newPassword: z
    .string()
    .min(8, 'Fjalëkalimi duhet të ketë të paktën 8 karaktere'),
});

export const registerSchema = z.object({
  email: z.string().email('Email i pavlefshëm'),
  password: z.string().min(8, 'Fjalëkalimi duhet të ketë të paktën 8 karaktere'),
  firstName: z.string().min(2, 'Emri është i detyrueshëm'),
  lastName: z.string().min(2, 'Mbiemri është i detyrueshëm'),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type RefreshTokenInput = z.infer<typeof refreshTokenSchema>;
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
export type SetInitialPasswordInput = z.infer<typeof setInitialPasswordSchema>;
export type RegisterInput = z.infer<typeof registerSchema>;
